import { createAction } from 'react-async-client';

import {
    SET_NOTIFICATION_PERMISSION,
    SET_NOTIFICATION_SUBSCRIBED,
 } from 'constants/actionTypes.js';

export const setNotificationPermission = createAction(SET_NOTIFICATION_PERMISSION);
export const setNotificationSubscribed = createAction(SET_NOTIFICATION_SUBSCRIBED);
